export default __webpack_public_path__ + "static/media/projeto-sou-da-paz.be86330d.jpg";